import { HEX_292D38, HEX_3D526B, HEX_646A7E, HEX_959EB0 } from '@tanium/colors';
import { defineColor } from '@tanium/react-theme-definition';

export const AxisStroke = defineColor([HEX_292D38, HEX_3D526B]);
export const TickLabelText = defineColor([HEX_646A7E, HEX_959EB0]);
